const cardItems = [
  {
    title: '某选秀冠军被曝签约内幕：合同暗藏天价违约金',
    desc: '知情人士透露该选手实际签约条件与公开信息存在巨大差异，背后涉及多方资本博弈。每日大赛黑料独家深挖内幕细节。',
    tag: '选秀内幕',
    time: '3小时前',
    hot: true,
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20contract%20signing%20scene%20with%20mysterious%20atmosphere%2C%20dark%20office%20with%20warm%20golden%20pen%20on%20paper%2C%20tension%20and%20secrets%20aesthetic%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20business%20drama%20photography%20style&width=640&height=420&seq=card-01-2026&orientation=landscape',
  },
  {
    title: '综艺导师被指收钱保送选手，节目组紧急回应',
    desc: '网友扒出某导师与选手所属公司存在利益关联，节目组凌晨发布声明否认但未提供具体证据，引发更大质疑。',
    tag: '导师争议',
    time: '6小时前',
    hot: true,
    img: 'https://readdy.ai/api/search-image?query=TV%20studio%20with%20judges%20table%20in%20dramatic%20red%20lighting%2C%20controversy%20and%20tension%20atmosphere%2C%20reality%20show%20setting%20with%20mysterious%20shadows%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20dark%20moody%20aesthetic&width=640&height=420&seq=card-02-2026&orientation=landscape',
  },
  {
    title: '电竞战队内部矛盾升级：核心选手赛前突然离队',
    desc: '距离关键赛事仅72小时，战队官方尚未给出明确解释。知情人士爆料与管理层决策分歧有关，每日大赛黑料持续追踪。',
    tag: '电竞爆料',
    time: '9小时前',
    hot: false,
    img: 'https://readdy.ai/api/search-image?query=Empty%20esports%20gaming%20chair%20in%20dark%20arena%20with%20dramatic%20spotlight%2C%20abandoned%20competition%20setup%2C%20tense%20lonely%20atmosphere%2C%20cyberpunk%20aesthetic%20with%20crimson%20accents%2C%20cinematic%20photography%20with%20deep%20contrast&width=640&height=420&seq=card-03-2026&orientation=landscape',
  },
  {
    title: '网红主播大赛数据造假产业链曝光：明码标价',
    desc: '调查发现存在完整的刷票灰色产业链，从机器投票到人工水军一应俱全。多个平台被指默许甚至纵容此类行为。',
    tag: '深度调查',
    time: '1天前',
    hot: true,
    img: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20multiple%20phone%20screens%20glowing%2C%20digital%20manipulation%20aesthetic%2C%20mysterious%20hacker%20vibe%20with%20red%20accents%2C%20data%20fraud%20investigation%20mood%2C%20cinematic%20tech%20noir%20photography%20with%20deep%20shadows&width=640&height=420&seq=card-04-2026&orientation=landscape',
  },
  {
    title: '才艺大赛评委私下聊天记录泄露：选手被恶意低分',
    desc: '多位评委在群聊中讨论如何通过评分操控比赛走向，其中涉及对特定选手的偏见性评价。截图为每日大赛黑料独家获取。',
    tag: '评委黑幕',
    time: '2天前',
    hot: false,
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20group%20chat%20messages%20in%20dark%20setting%2C%20dramatic%20amber%20glow%20from%20screen%2C%20secrets%20and%20gossip%20atmosphere%2C%20nighttime%20mysterious%20aesthetic%2C%20cinematic%20low%20key%20photography%20with%20warm%20highlights&width=640&height=420&seq=card-05-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门黑料
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            每日大赛黑料精选，最火爆的大赛吃瓜内容一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, i) => (
            <article
              key={i}
              className={`rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3 flex items-center gap-2 flex-wrap">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                      热门
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 leading-snug hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <p className="mt-3 text-xs text-foreground-500">{item.time}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}